var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import QuestionnaireOrg from "../../../organisms/obligationsQuestionnaire/obligationsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AdviserObligationsAction, AdviserObligationsFormAction, } from "../../../../redux/actions/job_seeker_questionnaire";
import { updateNeedsQuestionnaire } from "../../../../redux/actions/dashboard";
import { forceBlrRecalculation } from "../../../../redux/actions/manage_users";
import { getQuestionnaireAttemptVariant, getQuestionnaireProgressWidth, } from "../../../../utils/questionnaireProgress";
/**
 * The Adviser Obligations Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function AdviserObligationsQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(""), error = _a[0], setError = _a[1];
    var _b = useState(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    //using selector hook to fetch data from the reducer
    var _c = useSelector(function (state) { return state.rootReducer.JobSeekerQuestionnaireReducer; }), adviserObligationsData = _c.adviserObligationsData, error_adviserObligations = _c.error_adviserObligations, loading = _c.loading, adviserObligationsFormData = _c.adviserObligationsFormData, success_adviserObligations_form = _c.success_adviserObligations_form, status = _c.status;
    useEffect(function () {
        // Client Obligations prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!adviserObligationsData || adviserObligationsData.length === 0) {
            dispatch(AdviserObligationsAction());
        }
    }, [dispatch]);
    useEffect(function () {
        // Client Obligations prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!adviserObligationsData || adviserObligationsData.length === 0) {
            dispatch(AdviserObligationsAction());
        }
    }, [dispatch]);
    var loginData = useSelector(function (state) { return state.rootReducer.userReducer; }).loginData;
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        setIsSubmitting(true);
        dispatch(AdviserObligationsFormAction(sanitizedData, loginData));
    };
    var handleBackBtn = function () {
        navigate("/questionnaire/clientObligations");
    };
    useEffect(function () {
        if (success_adviserObligations_form && isSubmitting) {
            dispatch(updateNeedsQuestionnaire(false));
            dispatch(forceBlrRecalculation());
            navigate("/dashboard");
        }
    }, [success_adviserObligations_form, isSubmitting, dispatch, navigate]);
    var contentString = "For advisers and customers to work well together, it's important that they both understand what they need to do and what they expect from each other. There is no right or wrong answer to these questions. If there is no need for the support listed just select \"No Extent\"";
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "Adviser Expectations", content: contentString, data: adviserObligationsData, responses: adviserObligationsFormData, loading: !adviserObligationsData || adviserObligationsData.length === 0, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "adviserObligations-w", width: getQuestionnaireProgressWidth("adviserObligations", getQuestionnaireAttemptVariant(quesAttemptDetails)) })] })));
}
export default AdviserObligationsQuestionnaire;
